import { render, staticRenderFns } from "./ManageFamily.vue?vue&type=template&id=08987f10&"
import script from "./ManageFamily.vue?vue&type=script&lang=js&"
export * from "./ManageFamily.vue?vue&type=script&lang=js&"
import style0 from "./ManageFamily.vue?vue&type=style&index=0&id=08987f10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports